import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-available-lab-timings',
  templateUrl: './available-lab-timings.component.html',
  styleUrls: ['./available-lab-timings.component.scss']
})
export class AvailableLabTimingsComponent implements OnInit {

  constructor() { }
  @Input() data;
  labAvailableTimings :[];
  ngOnInit(): void {
    //console.log(this.data);

    if(this.data !=null && this.data !=undefined && this.data.monday !=undefined)
    {
      this.labAvailableTimings =this.data.monday;
      //console.log(this.labAvailableTimings);

    }
  }

}
